module.exports = __webpack_public_path__ + "static/media/pullup-clips.dcfafc5b.png";